module.exports = __webpack_public_path__ + "img/collection-diamondJewelry050Carat.2b35004.webp";